var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { CommonModal } from '@appspotr/ui-kit';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { closeCreateAppFlow, deleteInCompleteApp, resetAppCreationState, toggleConfirmCancelPopUp, } from '@project/store/createAppFlow/actions';
import { ContactForMoreContainer, CreateAppCloseButton, CreateAppHeaderContainer, NonResponsiveContainer, } from '../styles';
import appspotrLogo from '../../../images/appspotr-logo-alt.png';
var CreateAppHeader = function () {
    var dispatch = useDispatch();
    var _a = useSelector(selectAppCreationFlow), openedCancelPopUp = _a.openedCancelPopUp, _b = _a.createdTemplateApp.id, id = _b === void 0 ? '' : _b, creationType = _a.creationType;
    return (_jsxs(CreateAppHeaderContainer, { children: [_jsxs(CommonModal, __assign({ title: 'Cancel App Creation?', modalType: "delete", cancel: "Continue App Creation", action: "Cancel", width: '560px', disabled: false, height: 'auto', active: openedCancelPopUp, hideModal: function () {
                    dispatch(toggleConfirmCancelPopUp(!openedCancelPopUp));
                }, onClick: function () {
                    if (id !== '' && creationType === 'TEMPLATE') {
                        dispatch(deleteInCompleteApp(id));
                    }
                    dispatch(closeCreateAppFlow());
                    dispatch(toggleConfirmCancelPopUp(!openedCancelPopUp));
                    dispatch(resetAppCreationState());
                } }, { children: [_jsx(NonResponsiveContainer, { children: "Are you sure you want to cancel App Creation? Any unsaved changes will be lost." }), _jsx(ContactForMoreContainer, { children: "If you need help or have any questions, please contact our support team at support@appspotr.com" })] })), _jsx("img", { src: appspotrLogo, alt: "logo", height: "24px", width: "130px" }), _jsx(CreateAppCloseButton, { children: _jsx(FontAwesomeIcon, { size: "lg", onClick: function (e) {
                        e.stopPropagation();
                        dispatch(toggleConfirmCancelPopUp(!openedCancelPopUp));
                    }, icon: faTimes }) })] }));
};
export default CreateAppHeader;
